var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow Up Right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M1.14645 10.8536C0.951184 10.6583 0.951184 10.3417 1.14645 10.1464L9.29289 2H4.46988C4.19374 2 3.96988 1.77614 3.96988 1.5C3.96988 1.22386 4.19374 1 4.46988 1H10.5C10.7761 1 11 1.22386 11 1.5V7.5C11 7.77614 10.7761 8 10.5 8C10.2239 8 10 7.77614 10 7.5V2.70711L1.85355 10.8536C1.65829 11.0488 1.34171 11.0488 1.14645 10.8536Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/arrow-up-right.fc5803855623ef2abd03b31dcb18ba95.svg";
export { ForwardRef as ReactComponent };